<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  document.querySelectorAll('a').forEach(link => {
  link.addEventListener('mouseover', function() {
    this.dataset.title = this.getAttribute('title'); // Store the title in a data attribute
    this.removeAttribute('title'); // Remove the title attribute to hide tooltip
  });
  link.addEventListener('mouseout', function() {
    this.setAttribute('title', this.dataset.title); // Restore the title attribute
  });
});
